module.exports = __webpack_public_path__ + "img/aboutUs_img5.b402f795.svg";